module.exports = __webpack_public_path__ + "static/media/credit-card.afea358d.svg";